export const EXPERIMENT_NAME_AA = 'jira_loss_aversion_standard_aa';
export const EXPERIMENT_NAME_AB = 'jira_loss_aversion_standard_ab';
